interface CategoryLike {
    id: string;
    parentCategoryId: string | null;
    subcategories?: CategoryLike[];
}

export function buildCategorySearchLabels<T extends CategoryLike>(
    categories: T[],
    getLabel: (item: T) => string,
): Map<string, string> {
    const labels = new Map<string, string>();

    const parentMap = new Map<
        string,
        { label: string; childLabels: string[] }
    >();
    for (const category of categories) {
        if (category.parentCategoryId != null) {
            continue;
        }
        const childLabels = (category.subcategories ?? [])
            .filter((sub): sub is T => categories.some((c) => c.id === sub.id))
            .map((sub) => getLabel(sub));
        parentMap.set(category.id, {
            label: getLabel(category),
            childLabels,
        });
    }

    for (const category of categories) {
        if (category.parentCategoryId == null) {
            const entry = parentMap.get(category.id);
            if (entry) {
                labels.set(
                    category.id,
                    [entry.label, ...entry.childLabels].join(" "),
                );
            }
        } else {
            const parentEntry = parentMap.get(category.parentCategoryId);
            const parentLabel = parentEntry?.label ?? "";
            labels.set(
                category.id,
                [parentLabel, getLabel(category)].join(" "),
            );
        }
    }

    return labels;
}
